import Swal from 'sweetalert2'

window._Alert = Swal.mixin({
    title: '',
    heightAuto: false,
})

export default class Alert {
    
    static success(message) {
        _Alert.fire({
            html: message,
            icon: 'success',
        })
    }
    
    static error(message) {
        _Alert.fire({
            html: message,
            icon: 'error',
        })
    }
    
    static danger(message) {
        _Alert.fire({
            html: message,
            icon: 'error',
        })
    }
    
    static warning(message) {
        _Alert.fire({
            html: message,
            icon: 'warning',
        })
    }
    
    static info(message) {
        _Alert.fire({
            html: message,
            icon: 'info',
        })
    }
    
    static question(message) {
        _Alert.fire({
            html: message,
            icon: 'question',
        })
    }

    /**
     * Resolve a promise after showing the message.
     *
     * @param message
     * @param type
     */
    static withAction(message, type = 'success') {
        return new Promise((resolve, reject) => {
            _Alert.fire({
                title: '',
                html: message,
                icon: type,
                confirmButtonColor: '#5F91BA',
                confirmButtonText: 'Ok',
                heightAuto: false
            }).then(resolve).catch(reject)
        })
    }

    /**
     * Resolve a promise if the answer is OK.
     *
     * @param message
     * @param type
     */
    static confirmation(message, type = 'question') {
        return new Promise((resolve, reject) => {
            _Alert.fire({
                title: '',
                html: message,
                icon: type,
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonColor: '#5F91BA',
                confirmButtonText: 'Ok',
                heightAuto: false
            }).then(result => {
                if (result.value) {
                    resolve(true)
                } else {
                    reject(false)
                }
            }).catch(() => {
                reject(false);
            })
        })
    }

    /**
     * Show a message alert with a delay to fade down.
     *
     * @param message
     */
    static withDelay(message, type = 'success', time = 2000) {
        _Alert.fire({
            title: "",
            html: message,
            icon: type,
            timer: time,
            showConfirmButton: false,
            heightAuto: false
        })
    }
    
    static timer(message, icon = 'success', confirmButtonText = 'Ok', confirmButtonColor = '#e5832f') {
        return new Promise((resolve, reject) => {
            _Alert.fire({
                html: message,
                icon: icon,
                confirmButtonColor: confirmButtonColor,
                confirmButtonText: confirmButtonText,
            }).then(resolve).catch(reject)
        })
    }

    static text(title, text){
        Swal.fire({
            title: title,
            html: text,
        })
    }
}